import React, { useEffect, useState } from 'react';
import PropTypes, { func } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import axios from 'axios';
import { Avatar, CircularProgress, Grid, Link } from '@material-ui/core';
import { ActiveBadge, MovBadge, VacBadge } from './StyledBadge';
import config from '../../../config/config.json';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div style={{ width: '100%' }}
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        // height: 224,
        marginBottom: theme.spacing(2),
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        width: '33%',
    },
    xl: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    tab: {
        maxWidth: 'none',
    },
    loaderWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(5),
    }
}));
export default function VerticalTabs() {
    const classes = useStyles();

    const [value, setValue] = useState(0);
    const [grupos, setGrupos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    let url = `${config.apiBaseUrl}/trabajador/por_grupo`;
    useEffect(() => {
        async function fetchData() {
            let response = await axios.get(url);
            console.log(response.data);
            setGrupos(response.data);

            setIsLoading(false);
        }
        fetchData();
        return () => {
            // cleanup
        }
    }, [])

    const handleChange = (event, newValue) => {
        setValue(newValue);

        // scroll suavizado cada vez que cambi ...
        const anchor = (event.target.ownerDocument || document).querySelector('#root');
        if (anchor) {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const getIniciales = (worker) => {
        const n = worker.nombre[0].toLowerCase();

        const apellidos = worker.apellidos.split(' ');
        const ap1 = apellidos[0][0].toLowerCase();
        const ap2 = apellidos[1][0].toLowerCase();

        return n + ap1 + ap2;
    }

    const TabComponent = grupos.map((grupo, id) => (
        <Tab label={grupo.grupo} {...a11yProps(id)} className={classes.tab} />
    ));

    const TabPanelComponent = grupos.map((grupo, idg) => {
        const WorkersComponent = grupo.trabajadores.map((worker, idw) => {
            let AvatarWithCurrentBadge;
            switch (worker.estado) {
                case 'Activo':
                    AvatarWithCurrentBadge =
                        <ActiveBadge
                            overlap="circle"
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            variant="dot"
                        >
                            <Avatar alt={worker.nombre} src={`./assets/files/avatar/all_trab/${getIniciales(worker)}.png`} className={classes.xl} />
                        </ActiveBadge>
                    break;
                case 'Movilizado':
                    AvatarWithCurrentBadge =
                        <MovBadge
                            overlap="circle"
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            variant="dot"
                        >
                            <Avatar alt={worker.nombre} src={`./assets/files/avatar/all_trab/${getIniciales(worker)}.png`} className={classes.xl} />
                        </MovBadge>
                    break;
                case 'Vacaciones':
                    AvatarWithCurrentBadge =
                        <VacBadge
                            overlap="circle"
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            variant="dot"
                        >
                            <Avatar alt={worker.nombre} src={`./assets/files/avatar/all_trab/${getIniciales(worker)}.png`} className={classes.xl} />
                        </VacBadge>
                    break;
            }
            return (
                <Grid item xs={12} sm={6} container key={idw} spacing={1}>
                    <Grid item>
                        {
                            AvatarWithCurrentBadge
                        }
                    </Grid>
                    <Grid item xs container direction="column" spacing={2}>
                        <Grid item xs>
                            <Link href="#" onClick={(event) => event.preventDefault()} variant="subtitle1" underline="none">
                                {`${worker.nombre} ${worker.apellidos}`}
                            </Link>
                            <Typography variant="body2" gutterBottom color="textSecondary">
                                {worker.plaza}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                {worker.estado}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            )
        });
        return (
            <TabPanel value={value} index={idg}>
                {/* <Typography variant="subtitle1" color="textPrimary">
                    {grupo.grupo}
                </Typography> */}
                <Grid container spacing={2}>
                    {
                        WorkersComponent
                    }
                </Grid>
            </TabPanel>
        )
    });

    if (isLoading)
        return (
            <div className={classes.loaderWrapper}>
                <CircularProgress color="secondary" />
            </div>
        )
    else
        return (
            <div className={classes.root}>
                <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={value}
                    onChange={handleChange}
                    aria-label="Vertical tabs example"
                    className={classes.tabs}
                >
                    {
                        TabComponent
                    }
                </Tabs>
                {
                    TabPanelComponent
                }
            </div>
        )

}